import { DisplayElementModel } from './display-element.model';
import { ButtonStyleModel } from './button-style.model';
import { LinkModel } from '../../Forms/models/link.model';

export class ButtonDisplayElementModel extends DisplayElementModel {
    declare styles: ButtonStyleModel;
    text: string;
    url: LinkModel;

    constructor(
        text?: string,
        url?: LinkModel,
        styles?: any
    ) {
        super();
        this.isBoundToGlobalStyles = true;
        this.text = text;
        this.url = new LinkModel(url);
        this.styles = new ButtonStyleModel(styles);
    }

    canRender(): boolean {
        return !!this.text && (!!this.url?.url || !!this.url?.mailTo);
    }

    clone(): ButtonDisplayElementModel {
        return new ButtonDisplayElementModel(
            this.text,
            JSON.parse(JSON.stringify(this.url)),
            JSON.parse(JSON.stringify(this.styles))
        );
    }

    async onUpdate(): Promise<boolean> {
        return false;
    }

    isEqual(other: ButtonDisplayElementModel): boolean {
        if (this.text !== other.text) {
            return false;
        }
        if (!this.url.equals(other.url)) {
            return false;
        }
        if (!this.styles.equals(other.styles, true)) {
            return false;
        }
        return true;
    }

    linkToUrlString(link: LinkModel): string {
        if (!link) {
            return null;
        }

        if (link.url) {
            return link.url;
        }

        if (link.mailTo) {
            return link.mailTo;
        }
    }
}
